<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Payment Order #{{ payment_id }}</p>
        <div v-if="payment" class="flex-container">
          <tooltip label="History" type="default" placement="left">
            <a class="button button-table is-small" @click="history()">
              <i class="fa fa-align-right"></i>
            </a>
          </tooltip>
          <tooltip v-if="parseInt(payment.payment) === 1 && parseInt(context.$store.state.config.user.revert_payment) === 1" label="Revert Payment" type="default" placement="left">
            <a class="button button-table is-small" @click="revertPayment()">
              <i class="fa fa-undo"></i>
            </a>
          </tooltip>
          <tooltip :label="parseInt(payment.protected) === 0 ? 'Protect' : 'Unprotect'" type="default" placement="left" v-if="parseInt(payment.payment) !== 1">
            <a class="button button-table is-small" @click="protect()"> <i :class="{'fa': true, 'fa-lock': parseInt(payment.protected) === 0, 'fa-unlock': parseInt(payment.protected) === 1}"></i></a>
          </tooltip>
          <tooltip label="Refresh" type="default" placement="left" v-if="parseInt(payment.payment) !== 1">
            <a class="button button-table is-small" @click="refresh()">
              <i class="fa fa-refresh"></i>
            </a>
          </tooltip>
          <a class="button is-danger" @click="dispute" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.dispute_payment) === 1)">Open Dispute</a>
          <a class="button is-info" @click="move" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.move_service_po) === 1)">Move</a>
          <input class="input" type="text" v-model="booking" placeholder="Search for booking" @keyup.enter="searchBooking(booking)">
        </div>
      </header>
      <section class="modal-card-body">
          <div class="content" v-if="payment">
          <h1>{{ getName() }}</h1>
          <h2 style="margin-top: 0px;"><b>Payment Deadline:</b> {{ payment.deadline }}</h2>
          <br>
          <br>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th></th>
                <th>Booking/Service</th>
                <th>Provider #</th>
                <th>Type</th>
                <th>Hotel</th>
                <th>Check-in</th>
                <th>Check-out</th>
                <th>Main PAX</th>
                <th>Invoice</th>
                <th>Value</th>
                <th>View</th>
                <!-- <th v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.move_service_po) === 1)">Move</th> -->
                <th v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.delete_service_po) === 1)">Delete</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="service in payment.payment_services">
                <tr v-if="parseInt(service.dispute) !== 1 && parseInt(service.deleted) === 0" :style="{'background': highlight.toUpperCase() === service.service.hotel.toUpperCase() ? '#F8FF00' : service.service.api_booking_id === booking || service.service.api_service_id === booking ? '#F7B538': ''}">
                  <td><input type="checkbox" v-model="services" :value="service.service.id"></td>
                  <td>{{ parseInt(service.service.integration) === 1 ? service.service.booking_id + '/' + service.service.service_id : parseInt(service.service.integration) === 2 ? service.service.api_booking_id + '/' + service.service.api_service_id : 'Manual/' + service.service.id }}<span class="ticket-tag" v-if="service.service.occurrence === 1"> (Ticket)</span></td>
                  <td>{{ service.service.api_supplier_id }}</td>
                  <td>Service</td>
                  <td>{{ service.service.room.hotel.name }}</td>
                  <td>{{ parseDate(service.service.service_date) }}</td>
                  <td>{{ parseDate(service.service.checkout) }}</td>
                  <td>{{ service.service.main_pax }}</td>
                  <td><a v-show="service.service.invoice_services_v2 && service.service.invoice_services_v2.deleted === 0 && service.service.invoice_services_v2.dispute !== 1" :style="{'color': service.service.invoice_services_v2 && service.service.invoice_services_v2.invoice.payment === 1 ? 'green': 'red'}" @click="openInvoice(service.service.invoice_services_v2.invoice_id)">{{ service.service.invoice_services_v2 ? service.service.invoice_services_v2.invoice_id : ''}}</a></td>
                  <td style="width: 150px;">+{{ service.service.room.provider_price }}</td>
                  <td style="text-align: center">
                    <tooltip label="View" type="default" placement="left">
                      <a class="button button-table is-small" @click="url(service.service.id)">
                        <i class="fa fa-eye"></i>
                      </a>
                    </tooltip>
                  </td>
                  <!-- <td style="text-align: center" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.move_service_po) === 1)">
                    <input class="button button-table is-small" v-model="move_service" style="width: 50px" @keyup.enter="moveService(move_service, service.service.id, 0)">
                  </td> -->
                  <td style="text-align: center" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.delete_service_po) === 1)">
                    <a class="button button-table is-small" @click="delService(service.service.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
                <tr v-for="payment_financial in service.service.financial" :style="{'background': service.service.api_booking_id === booking || service.service.api_service_id === booking ? '#F7B538' : ''}" v-if="parseFloat(payment_financial.net_price) !== 0 && payment_financial.payment_financials && payment_financial.payment_financials.payment_id === payment.id && parseInt(payment_financial.payment_financials.deleted) !== 1 && payment_financial.payment_financials.dispute !== 1">
                  <td><input type="checkbox" v-model="financials" :value="payment_financial.payment_financials.financial_id"></td>
                  <td class="financial">{{ parseInt(service.service.integration) === 1 ? service.service.booking_id + '/' + service.service.service_id : service.service.api_booking_id + '/' + service.service.api_service_id }}</td>
                  <td class="financial" colspan="6">
                    {{ payment_financial.observation }}
                    <tooltip label="Separar Cobrança" type="default" placement="right">
                      <a class="button button-table is-small"
                        v-if="parseInt(payment_financial.type) == 1 && payment_financial.observation === 'Commission'"
                        @click="CommissionCharged(payment_financial.payment_financials.financial_id)">
                        <i class="fa fa-external-link"></i>
                      </a>
                    </tooltip>
                  </td>
                  <td><a :style="{'color': payment_financial.payment_financials.invoice_financials && payment_financial.payment_financials.invoice_financials.invoice.payment === 1 ? 'green': 'red'}" @click="openInvoice(payment_financial.payment_financials.invoice_financials.invoice_id)">{{ payment_financial.payment_financials.invoice_financials ? payment_financial.payment_financials.invoice_financials.invoice_id : '' }}</a></td>
                  <td class="financial">{{ parseInt(payment_financial.type) == 2 ? '+' : parseFloat(payment_financial.net_price) > 0 ? '-' : ''}}{{ payment_financial.net_price }}</td>
                  <td style="text-align: center;">
                    <tooltip label="View" type="default" placement="left">
                      <a class="button button-table is-small" @click="url(payment_financial.service_id)">
                        <i class="fa fa-eye"></i>
                      </a>
                    </tooltip>
                  </td>
                  <td style="text-align: center" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.refunds_po) === 1)">
                    <a class="button button-table is-small" @click="delFinancial(payment_financial.payment_financials.financial_id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </template>
              <tr v-for="payment_financial in payment.payment_financials" :style="{'background': payment_financial.financial.service.api_booking_id === booking || payment_financial.financial.service.api_service_id === booking ? '#F7B538': ''}" v-if="parseFloat(payment_financial.net_price) !== 0 && showFinancial(payment_financial.financial.service.id) && parseInt(payment_financial.deleted) !== 1 && payment_financial.dispute !== 1">
                <td><input type="checkbox" v-model="financials" :value="payment_financial.financial.id"></td>
                <td class="financial">{{ parseInt(payment_financial.financial.service.integration) === 1 ? payment_financial.financial.service.booking_id + '/' + payment_financial.financial.service.service_id : payment_financial.financial.service.api_booking_id + '/' + payment_financial.financial.service.api_service_id }}
                  <span class="ticket-tag" v-if="payment_financial.financial.service.occurrence === 1"> (Ticket)</span>
                </td>
                <td></td>
                <td class="financial">{{ payment_financial.financial.observation }}</td>
                <td>{{ payment_financial.financial.service.hotel }}</td>
                <td>{{ parseDate(payment_financial.financial.service.service_date) }}</td>
                <td>{{ parseDate(payment_financial.financial.service.checkout) }}</td>
                <td>{{ payment_financial.financial.service.main_pax }}</td>
                <td><a :style="{'color': payment_financial.invoice_financials && payment_financial.invoice_financials.invoice.payment === 1 ? 'green': 'red'}" @click="openInvoice(payment_financial.invoice_financials.invoice_id)">{{ payment_financial.invoice_financials ? payment_financial.invoice_financials.invoice_id : '' }}</a></td>
                <td class="financial">{{ parseInt(payment_financial.financial.type) == 2 ? '+' : parseFloat(payment_financial.financial.net_price) > 0 ? '-' : ''}}{{ payment_financial.financial.net_price }}</td>
                <td style="text-align: center;">
                  <tooltip label="View" type="default" placement="left">
                    <a class="button button-table is-small" @click="url(payment_financial.financial.service_id)">
                      <i class="fa fa-eye"></i>
                    </a>
                  </tooltip>
                </td>
                <td style="text-align: center" v-show="(parseInt(payment.protected) !== 1 && parseInt(context.$store.state.config.user.refunds_po) === 1)">
                  <a class="button button-table is-small" @click="delFinancial(payment_financial.financial.id)">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="9" style="border:none; text-align: right; width: 900px;"><b>SUB TOTAL</b></td>
                <td colspan="1"><b>{{ calcServices() }} {{ payment.currency }}</b></td>
              </tr>
            </tfoot>
          </table>
        <template v-if="showDebitCreditExtra()">
          <h2 style="margin-top: 0px;"><b>Payment Credits/Debits</b></h2>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>#</th>
                <th>Type</th>
                <th>Description</th>
                <th>Charge At</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="payment_financial_extra in payment.payment_financials_extra">
                <tr>
                  <td>{{ payment_financial_extra.id }}</td>
                  <td>{{ payment_financial_extra.type == 1 ? 'Credit' : 'Debit'}}</td>
                  <td>{{ payment_financial_extra.observation }}</td>
                  <td>{{ payment_financial_extra.created_at }}</td>
                  <td>{{ payment_financial_extra.type == 2 ? '+' : parseFloat(payment_financial_extra.net_price) > 0 ? '-' : ''}}{{ payment_financial_extra.net_price }}</td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr>
                <td style="border:none; text-align: right" colspan="4"><b>SUB TOTAL</b></td>
                <td><b>{{ calcDebitCreditExtra() }} {{ payment.currency }}</b></td>
              </tr>
            </tfoot>
          </table>
        </template>
        <h2 style="margin-top: 0px; text-align: right;"><b>Total</b> {{ payment.value }} {{ payment.currency }}</h2>
        <!-- NOTA FISCAL -->
        <section v-if="payment.payment_n_f[0]">
          <table class="table is-bordered is-striped is-narrow" style="max-width: fit-content;">
            <thead>
              <tr>
                <th>Nota Fiscal</th>
                <th>Hotel/Hotelier</th>
                <th>CNPJ (Nota Fiscal)</th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="payment_nf in payment.payment_n_f" :key="payment_nf.id">
                  <td>{{ payment_nf.number }}</td>
                  <td v-if="payment_nf.hotel">{{ payment_nf.hotel['name'] }}</td>
                  <td v-if="payment_nf.chain">{{ payment_nf.chain['name'] }}</td>
                  <td v-if="!payment_nf.hotel && !payment_nf.chain">CNPJ sem vinculo em sistema</td>
                  <td>{{ parseCNPJ(payment_nf.cnpj) }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </section>
          <!-- INVOICE NUMBER -->
          <div class="extra-info" v-if="payment.invoice_number !== '' && payment.invoice_number !== null">
            <b>Invoice Number: </b> {{ payment.invoice_number }}
          </div>
          <!-- SEU NUMERO -->
          <div class="extra-info" v-if="payment.seu_numero !== '' && payment.seu_numero !== null">
            <b>Seu Numero/Num Documento: </b> {{ payment.seu_numero }}
          </div>
          <!-- OBSERVACOES -->
          <div class="extra-info" v-if="payment.comments !== '' && payment.comments !== null">
            <b>Observações: </b> {{ payment.comments }}
          </div>
        <charge :payment="payment" :occurrence="null" :context="context" v-if="parseInt(payment.payment) !== 1 && parseInt(payment.protected) !== 1"></charge>
        <table class="table is-bordered" style="width: 400px; text-align: right;" v-if="parseInt(payment.payment) == 1">
          <tbody>
            <tr>
              <td colspan="2" style="text-align: center;"><b>Payment Info</b></td>
            </tr>
            <tr>
              <td><b>Status</b></td>
              <td>{{ parseInt(payment.payment) == 1 ? 'Payed': 'Unpaid'}}</td>
            </tr>
            <tr>
              <td><b>Deposit Date</b></td>
              <td>{{ (payment.deposit_date != null ? payment.deposit_date : payment.paid_at)}}</td>
            </tr>
            <tr>
              <td><b>Payment Method</b></td>
              <td>{{ parsePaymentMethod(payment.payment_method) }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <template>
              <a class="button is-success" @click="pdf">Export PDF</a>
              <a class="button is-info" @click="csv">Export CSV</a>
              <a class="button is-warning" @click="xls">Export XLS</a>
            </template>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  import Charge from '../../../services/V2/Charge.vue'
  import Payment from './payment'
  import Invoice from '../invoice/invoice'
  export default {
    props: {
      context: {
        type: Object
      },
      payment_id: {
        type: Number,
        required: true
      },
      edit: {
        type: Boolean,
        default: false
      },
      callback: {
        type: String
      },
      highlight: {
        type: String,
        default: '',
        required: false
      }
    },
    data () {
      return {
        payment: null,
        booking: null,
        move_service: null,
        services: [],
        financials: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.$root.$on('reloadpayment', reload => {
          this.loadData()
        })
      })
    },
    methods: {
      parseCNPJ (content) {
        if (content) {
          return content.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        }
      },
      CommissionCharged (commission) {
        if (window.confirm('Tem certeza de que deseja colocar essa comissão em uma Payment Order separada?')) {
          const API_URL = this.context.$store.state.config.apiURL
          this.context.$http.post(API_URL + '/V2/payment/commission_charged', {commission: commission}).then((response) => {
            this.close(false)
            if (response.status === 200) {
              this.message('success', 'Success', response.body.message)
            }
          }).catch((error) => {
            this.close(true)
            this.message('danger', 'Error', error.body.message, 60000)
          })
        }
      },
      revertPayment () {
        if (window.confirm('Are you sure you want to revert the payment of PO #' + this.payment.id)) {
          let API_URL = this.context.$store.state.config.apiURL
          this.context.$http.post(API_URL + '/V2/payment/revert_payment', {payment_id: this.payment.id})
            .then((response) => {
              this.close(true)
              let propsData = {
                title: 'Success',
                message: 'The payment was successfully reverted for PO #' + this.payment.id,
                type: 'success',
                direction: 'down',
                duration: 8500,
                showCloseButton: true
              }
              message.openMessage(propsData)
            }, (response) => {
              this.context.message('danger', 'Error', response.body)
            })
        }
      },
      dispute () {
        if (this.services.length > 0) {
          if (window.confirm('Are you sure you want to open a dispute for the services')) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/dispute/payment', {services: this.services, payment: this.payment_id}).then((response) => {
              let propsData = {
                title: 'Success',
                message: 'The services dispute was successfully open',
                type: 'success',
                direction: 'down',
                duration: 8500,
                showCloseButton: true
              }
              message.openMessage(propsData)
              this.loadData()
            }, (response) => {
              this.context.message('danger', 'Error', response.body)
            })
          }
        }
      },
      moveService (payment, service, financial) {
        if (window.confirm('Are you sure want to move the service to payment #' + payment)) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/move_service', {payments: payment, services: service, financials: financial}).then((response) => {
            if (response.body === '0') {
              this.context.message('danger', 'Error', 'A payment #' + payment + ' não existe')
              this.close(true)
            } else if (response.body === '1') {
              this.context.message('danger', 'Error', 'A payment #' + payment + ' esta protegida ou paga')
              this.close(true)
            } else if (response.body === '2') {
              this.context.message('danger', 'Error', 'A payment #' + payment + ' não pertence ao mesmo fornecedor')
              this.close(true)
            } else if (response.body === '3') {
              this.context.message('danger', 'Error', 'A payment #' + payment + ' não pertence a mesma moeda')
              this.close(true)
            } else {
              let propsData = {
                title: 'Success',
                message: 'The service was successfully moved to payment #' + payment,
                type: 'success',
                direction: 'down',
                duration: 8500,
                showCloseButton: true
              }
              message.openMessage(propsData)
              this.loadData()
            }
          }, (response) => {
            this.context.message('danger', 'Error', response.body)
          })
        }
      },
      move () {
        if ((this.services.length > 0) || (this.financials.length > 0)) {
          let payment = window.prompt('Payment to move services and finances')
          if ((payment !== '') && (payment !== null)) {
            if (window.confirm('Are you sure want to move the service to payment #' + payment)) {
              this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/move_all', {payment: payment, services: this.services, financials: this.financials}).then((response) => {
                if (response.body === '0') {
                  this.context.message('danger', 'Error', 'A payment #' + payment + ' não existe')
                  this.close(true)
                } else if (response.body === '1') {
                  this.context.message('danger', 'Error', 'A payment #' + payment + ' esta protegida ou paga')
                  this.close(true)
                } else if (response.body === '2') {
                  this.context.message('danger', 'Error', 'A payment #' + payment + ' não pertence ao mesmo fornecedor')
                  this.close(true)
                } else if (response.body === '3') {
                  this.context.message('danger', 'Error', 'A payment #' + payment + ' não pertence a mesma moeda')
                  this.close(true)
                } else {
                  let propsData = {
                    title: 'Success',
                    message: 'The services and financials was successfully moved to payment #' + payment,
                    type: 'success',
                    direction: 'down',
                    duration: 8500,
                    showCloseButton: true
                  }
                  message.openMessage(propsData)
                  this.loadData()
                }
              }, (response) => {
                this.context.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      delService (id) {
        if (window.confirm('Are you sure you want to exclude service #' + id)) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/exclude_service', {service: id}).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The service was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
            this.context.message('danger', 'Error', response.body)
          })
        }
      },
      delFinancial (id) {
        if (window.confirm('Are you sure you want to move financial #' + id + ' to refunds')) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/exclude_financial', {financial_id: id}).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The service was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
            this.context.message('danger', 'Error', response.body)
          })
        }
      },
      openInvoice (id) {
        let propsData = {
          context: this.context,
          invoice_id: id,
          edit: true,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      history () {
        let propsData = {
          context: this.context,
          payment_id: this.payment.id,
          callback: ''
        }
        Payment.openHistoryPayment(propsData)
      },
      searchBooking (booking) {
        for (const tr of document.querySelectorAll('tr')) {
          if (tr.textContent.includes(booking)) {
            tr.scrollIntoView(false)
          }
        }
      },
      showFinancial (service) {
        return this.payment.payment_services.filter(serviceTmp => {
          return serviceTmp.service.id === service
        }).length === 0
      },
      parsePaymentMethod (method) {
        if (method !== null) {
          let methodName = ''
          if (parseInt(method.method_type) === 1) {
            methodName = 'CARD - ' + method.card_number + ' - ' + method.card_flag
          } else {
            methodName = 'BANK - ' + method.bank
            if (method.account !== null) {
              methodName = methodName + ' - ' + method.account
            }
            if (method.agency !== null) {
              methodName = methodName + ' - ' + method.agency
            }
          }
          return methodName
        } else {
          return this.payment.origin_bank_name
        }
      },
      url (service) {
        window.open('#/services/service/' + service)
      },
      showExclude () {
        return (parseInt(this.payment.payment) !== 1) && (parseInt(this.payment.protected) === 0)
      },
      getName () {
        if (this.payment.provider !== null) {
          return this.payment.provider.name + ' - ' + 'Provider'
        } else if (this.payment.hotel !== null) {
          return this.payment.hotel.name + ' - ' + 'Hotel'
        } else if (this.payment.chain !== null) {
          return this.payment.chain.name + ' - ' + 'Hotelier'
        } else if (this.payment.custom !== null) {
          return 'Custom'
        }
      },
      calcServices () {
        let total = 0
        let cedDeb = 0
        this.payment.payment_services.forEach(service => {
          if ((parseInt(service.deleted) === 0) && (service.dispute !== 1)) {
            total = total + (parseFloat(service.service.room.provider_price))
          }
          service.service.financial.forEach(financial => {
            if (financial.payment_financials && financial.payment_financials.payment_id === this.payment.id && parseInt(financial.payment_financials.deleted) !== 1 && (financial.payment_financials.dispute !== 1)) {
              if (parseInt(financial.type) === 2) {
                cedDeb = cedDeb + (parseFloat(financial.net_price))
              } else {
                cedDeb = cedDeb - (parseFloat(financial.net_price))
              }
            }
          })
        })
        this.payment.payment_financials.forEach(financial => {
          if (this.showFinancial(financial.financial.service.id) && parseInt(financial.deleted) !== 1 && parseInt(financial.dispute) !== 1) {
            if (parseInt(financial.financial.type) === 2) {
              cedDeb = cedDeb + (parseFloat(financial.financial.net_price))
            } else {
              cedDeb = cedDeb - (parseFloat(financial.financial.net_price))
            }
          }
        })
        total = total + cedDeb
        return total.toFixed(2)
      },
      calcDebitCreditExtra () {
        let total = 0
        for (var i = 0; i < this.payment.payment_financials_extra.length; i++) {
          if (parseInt(this.payment.payment_financials_extra[i].type) === 2) {
            total = total + parseFloat(this.payment.payment_financials_extra[i].net_price)
          } else {
            total = total - parseFloat(this.payment.payment_financials_extra[i].net_price)
          }
        }
        return total.toFixed(2)
      },
      showDebitCreditExtra () {
        return this.payment.payment_financials_extra.length > 0
      },
      refresh () {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/refresh', {payments: [this.payment.id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The payment order was successfully refreshed',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          this.loadData(true)
        }, (response) => {
          this.context.message('danger', 'Error', response.body)
        })
      },
      protect () {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/payment/protect', {payments: [this.payment.id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The payment protection has been applied',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          this.loadData(true)
        }, (response) => {
          this.context.message('danger', 'Error', response.body)
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/V2/payment/' + this.payment_id).then((response) => {
          this.payment = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
          this.services = []
          this.financials = []
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      close (closeOnly, result) {
        if ((!closeOnly) && (typeof this.context[this.callback] === 'function')) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      pdf () {
        window.location.href = this.context.$store.state.config.apiURL + '/V2/payment/pdf/' + this.payment_id
      },
      xls () {
        window.location.href = this.context.$store.state.config.apiURL + '/V2/payment/xls/' + this.payment_id
      },
      csv () {
        window.location.href = this.context.$store.state.config.apiURL + '/V2/payment/csv/' + this.payment_id
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
      // exclude (id, service) {
      //   if (window.confirm('You are sure exclude service #' + service)) {
      //     this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/exclude_service', {payment: this.payment_id, service: id}).then((response) => {
      //       let propsData = {
      //         title: 'Success',
      //         message: 'The service was successfully removed',
      //         type: 'success',
      //         direction: 'down',
      //         duration: 4500,
      //         showCloseButton: true
      //       }
      //       message.openMessage(propsData)
      //       this.loadData()
      //     }, (response) => {
      //       this.context.message('danger', 'Error', response.body)
      //     })
      //   }
      // },
      // excludeAll () {
      //   if (window.confirm('You are sure exclude all services')) {
      //     for (var i = 0; i < this.payment.payment_services.length; i++) {
      //       this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/exclude_service', {payment: this.payment_id, service: this.payment.payment_services[i].service_id}).then((response) => {
      //         let propsData = {
      //           title: 'Success',
      //           message: 'The service was successfully removed',
      //           type: 'success',
      //           direction: 'down',
      //           duration: 4500,
      //           showCloseButton: true
      //         }
      //         message.openMessage(propsData)
      //         this.loadData()
      //       }, (response) => {
      //         this.context.message('danger', 'Error', response.body)
      //       })
      //     }
      //   }
      // },
      // excludeFinancial (id) {
      //   if (window.confirm('You are sure exclude financial #' + id)) {
      //     this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/exclude_financial', {payment: this.payment_id, financial: id}).then((response) => {
      //       let propsData = {
      //         title: 'Success',
      //         message: 'The financial was successfully removed',
      //         type: 'success',
      //         direction: 'down',
      //         duration: 4500,
      //         showCloseButton: true
      //       }
      //       message.openMessage(propsData)
      //       this.loadData()
      //     }, (response) => {
      //       this.context.message('danger', 'Error', response.body)
      //     })
      //   }
      // }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip,
      Charge
    }
  }
</script>
<style lang="scss" scoped>

.flex-container {
  display: flex;
  gap: 5px;
  align-items: center;
}

.financial {
  color: #91181c;
  font-weight: bold;
}

.extra-info {
  border: solid;
  border-width: 1px;
  border-color: rgba(155, 155, 155, 0.685);
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  max-width: fit-content;
}

.ticket-tag {
  font-style: italic;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// Payment.vue?10081979